import script from "./EditCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCollection.vue?vue&type=script&setup=true&lang=js"

import "./EditCollection.vue?vue&type=style&index=0&id=03d38bc9&scoped=true&lang=scss"
script.__scopeId = "data-v-03d38bc9"

export default script